import styled from 'styled-components';
import { Table as DefaultTable } from 'components/shared';

export const Table = styled(DefaultTable)``;
